import Request from 'gd-request';

export default class ApiCRM {

    // accounts
    newAccount(params) {
        return new Request(this, 'POST', 'crm/accounts', params);
    }

    getAccounts() {
        return new Request(this, 'GET', 'crm/accounts');
    }

    updateAccount(id, params) {
        return new Request(this, 'PUT', 'crm/account/{0}'.f(id), params);
    }

    getAccount(id) {
        return new Request(this, 'GET ', 'crm/account/{0}'.f(id));
    }

    deleteAccount(id) {
        return new Request(this, 'DELETE', 'crm/account/{0}'.f(id));
    }

    // contacts
    newContact(params) {
        return new Request(this, 'POST', 'crm/contacts', params);
    }

    getContacts() {
        return new Request(this, 'GET', 'crm/contacts');
    }

    updateContact(id, params) {
        return new Request(this, 'PUT', 'crm/contact/{0}'.f(id), params);
    }

    getContact(id) {
        return new Request(this, 'GET ', 'crm/contact/{0}'.f(id));
    }

    deleteContact(id) {
        return new Request(this, 'DELETE', 'crm/contact/{0}'.f(id));
    }

    inviteContact(id) {
        return new Request(this, 'POST', 'crm/contact/{0}/invite'.f(id));
    }

    createCustomer(payload) {
        return new Request(this, 'POST', 'new/customer', payload);
    }
}